interface Props {
  line?: string;
  newclass?: string;
}

const Authorize: React.FC<Props> = ({
  line = "Goodhand is Authorized Channel Partner for UAE Government Services",
  newclass = "",
}) => {
  return (
    <div
      className={`font-12 ff-semibold text-center glair-wrap bg-main d-flex align-items-center gap-1 px-3 my-3 rounded-pill ${newclass}`}
      style={{ width: "fit-content" }}
    >
      <span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.74904 0L6.82288 0.00438058L6.85981 0.00938706L6.89798 0.0175225L6.96744 0.0387996C7.01542 0.0564867 7.06103 0.0800278 7.10324 0.108889L7.16833 0.160205L7.3279 0.296629C8.59034 1.3452 10.1858 1.90825 11.8268 1.88428L12.0408 1.87802C12.1807 1.87164 12.3187 1.91238 12.4328 1.99373C12.5468 2.07508 12.6302 2.19234 12.6697 2.32672C12.9772 3.3728 13.0713 4.47001 12.9464 5.55317C12.8215 6.63633 12.4802 7.68333 11.9426 8.63195C11.4051 9.58058 10.6824 10.4115 9.81737 11.0753C8.95237 11.739 7.96277 12.2222 6.90737 12.496C6.80435 12.5227 6.69623 12.5227 6.59321 12.496C5.53775 12.2223 4.54808 11.7392 3.68302 11.0754C2.81795 10.4117 2.09514 9.58077 1.55755 8.63213C1.01995 7.6835 0.678533 6.63648 0.553588 5.55329C0.428644 4.47009 0.52272 3.37284 0.830226 2.32672C0.869721 2.19234 0.953158 2.07508 1.06718 1.99373C1.18121 1.91238 1.31923 1.87164 1.45915 1.87802C3.17226 1.95633 4.85291 1.3924 6.17205 0.296629L6.33664 0.155824L6.39671 0.108889C6.43892 0.0800278 6.48454 0.0564867 6.53251 0.0387996L6.6026 0.0175225C6.62713 0.0115984 6.652 0.00720922 6.67707 0.00438058L6.74904 0ZM9.07076 4.56396C9.01264 4.50577 8.94362 4.45961 8.86765 4.42812C8.79168 4.39663 8.71024 4.38042 8.628 4.38042C8.54576 4.38042 8.46433 4.39663 8.38836 4.42812C8.31239 4.45961 8.24337 4.50577 8.18525 4.56396L6.12449 6.62409L5.31533 5.81556L5.25651 5.76361C5.13073 5.66636 4.97264 5.62062 4.81436 5.6357C4.65608 5.65078 4.50948 5.72554 4.40432 5.84479C4.29917 5.96405 4.24335 6.11886 4.2482 6.27778C4.25305 6.4367 4.31822 6.58782 4.43045 6.70044L5.68205 7.95204L5.74088 8.00398C5.86128 8.09738 6.01163 8.14364 6.16372 8.13407C6.3158 8.12451 6.45917 8.05978 6.56693 7.95204L9.07013 5.44884L9.12207 5.39001C9.21547 5.26961 9.26173 5.11926 9.25217 4.96717C9.24261 4.81509 9.17788 4.67172 9.07013 4.56396H9.07076Z"
            fill="white"
          />
        </svg>
      </span>
      <span className="ms-1 glair-blue">{line ?? "GoodHand is officially authorized by Dubai Immigration (GDRFA)."}</span>
    </div>
  );
};

export default Authorize;